/**
 * Element's window may differ from the one within React instance
 * if element rendered within iframe.
 * See https://github.com/sanniassin/react-input-mask/issues/182
 */
export const getElementDocument = element => element == null ? void 0 : element.ownerDocument;
export const getElementWindow = element => {
  var _getElementDocument;
  return (_getElementDocument = getElementDocument(element)) == null ? void 0 : _getElementDocument.defaultView;
};
export const isDOMElement = element => {
  const elementWindow = getElementWindow(element);
  return !!elementWindow && element instanceof elementWindow.HTMLElement;
};
export const findLastIndex = (array, predicate) => {
  if (array != null && array.length) {
    for (let i = (array == null ? void 0 : array.length) - 1; i >= 0; i -= 1) {
      const x = array[i];
      if (predicate != null && predicate(x, i)) {
        return i;
      }
    }
  }
  return -1;
};
export const repeat = (string, n = 1) => {
  let result = '';
  for (let i = 0; i < n; i += 1) {
    result += string;
  }
  return result;
};
export const setInputSelection = (input, start, end) => {
  if (end === undefined) {
    end = start;
  }
  input == null ? void 0 : input.setSelectionRange(start, end);
};
export const getInputSelection = input => {
  const start = (input == null ? void 0 : input.selectionStart) || null;
  const end = (input == null ? void 0 : input.selectionEnd) || null;
  const length = start && end ? end - start : 0;
  return {
    start,
    end,
    length
  };
};
export const isInputFocused = input => {
  const inputDocument = input == null ? void 0 : input.ownerDocument;
  return (inputDocument == null ? void 0 : inputDocument.hasFocus()) && (inputDocument == null ? void 0 : inputDocument.activeElement) === input || false;
};